import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { User } from '../models/user.model';
import { ApiService } from './api.service';
import { Http } from '@angular/http';
import { JwtService } from './jwt.service';
import { Observable } from 'rxjs/Observable';
import { SimpleGlobal } from "ng2-simple-global";

@Injectable()
export class UserService {
    private currentUserObject = new BehaviorSubject<User>(new User());
    public currentUser = this.currentUserObject;
    private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
    public isAuthenticated = this.isAuthenticatedSubject.asObservable();

    constructor(
        private apiService: ApiService,
        private http: Http,
        private jwtService: JwtService,
        public global: SimpleGlobal,
    ) {
    }

    populate() {
        if (this.jwtService.getToken()) {

            this.apiService.get('user').subscribe(
                data => this.setAuth(data),
                err => this.purgeAuth()
            );
        } else {
            this.purgeAuth();
        }
    }

    handleError(): void {
        console.log('error');
    }

    setAuth(user: User) {
        if (!this.jwtService.getToken()) {
            this.jwtService.saveToken(user.token);
        }
        this.currentUserObject.next(user);
        this.isAuthenticatedSubject.next(true);
    }

    purgeAuth(): void {
        this.jwtService.destroyToken();
        this.currentUserObject.next(new User());
        this.isAuthenticatedSubject.next(false);

        // return this.apiService.post('logout');
    }

    attemptAuth(type, credentials): Observable<User> {
        const route = (type === 'login') ? 'clients/login' : '';
        return this.apiService.post(route, credentials)
            .map(data => {
                this.setAuth(data);
                return data;
            });
    }

    getLoggedInUser(): Observable<User> {
        return this.apiService.get('user');
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/user.service.ts